module.exports = __webpack_public_path__ + "media/images/application/template/meganav/specialised-containers/high-cube-1c77875e3692df1fe9b18e6202d16b11.png";